var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDrinkingWater(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#drinking-water_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.317 8.225a2.226 2.226 0 002.772 1.497 2.228 2.228 0 001.497-2.772l-.913-3.055a2.228 2.228 0 00-4.27 1.275l.914 3.055zM7.551 33.79l-3.134.775a2.228 2.228 0 101.071 4.325l3.134-.776a2.227 2.227 0 10-1.07-4.325zM35.706 9.911a2.228 2.228 0 002.728-1.575L39.3 5.11a2.228 2.228 0 10-4.303-1.154l-.865 3.228a2.228 2.228 0 001.575 2.728zM10.334 24.56a2.228 2.228 0 00-1.576-2.728l-3.227-.865a2.228 2.228 0 10-1.153 4.304l3.227.865a2.228 2.228 0 002.729-1.576zM25.11 41.738a13.26 13.26 0 01-.35-.16c-5.607-2.678-8.507-8.986-6.896-15 1.659-6.19 7.697-10.267 14.046-9.483.157.02.316.043.474.068a2.228 2.228 0 00.71-4.399 17.365 17.365 0 00-12.408 2.715 17.36 17.36 0 00-7.126 9.947c-2.166 8.086 1.736 16.57 9.28 20.172.154.073.313.146.47.216a2.228 2.228 0 001.8-4.076zM16.014 11.513l-2.223-2.21a2.228 2.228 0 00-3.142 3.16l2.223 2.21a2.228 2.228 0 103.141-3.16zM15.127 44.149a2.228 2.228 0 00-3.15-.015l-2.295 2.272a2.228 2.228 0 003.136 3.166l2.294-2.273c.874-.866.88-2.276.015-3.15z",
    fill: "#203950"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#drinking-water_svg__clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.898 23.487a.74.74 0 00-.528-.243H29.118a.72.72 0 00-.528.243.815.815 0 00-.15.607l4.375 32.897c.038.364.34.648.679.648h17.5c.34 0 .642-.284.68-.648l4.375-32.897c.038-.202-.038-.445-.15-.607zM50.391 56.14H34.097l-2.904-21.77c1.999-.849 3.093-.363 4.45.243.944.405 1.962.89 3.32.89.98 0 2.112-.242 3.545-.89 2.301-1.133 3.47-.606 4.941.041.943.405 1.962.89 3.32.89.716 0 1.508-.121 2.451-.445l-2.829 21.041zm3.056-22.78c-2.64 1.132-3.998.525-5.432-.122-1.509-.688-3.168-1.416-6.035 0-2.866 1.335-4.262.688-5.77 0-1.358-.607-2.83-1.255-5.206-.364L29.91 24.74h24.668l-1.131 8.62z",
    fill: "#203950",
    stroke: "#203950",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "drinking-water_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h59.286v60H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "drinking-water_svg__clip1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(26.428 21.429)",
    d: "M0 0h31.429v37.857H0z"
  })))));
}

export default SvgDrinkingWater;